<template>
  <div style="width: 100%">
    <div>
      <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="add">
        新增
      </el-button>
    </div>
    <div style="width: 100%">
      <el-table
          :data="tableData"
          style="width: 100%;">
        <el-table-column
            prop="id"
            align="center"
            label="id"
            width="360px">
        </el-table-column>
        <el-table-column
            prop="leaderName"
            align="center"
            label="领导姓名"
            width="360px">
        </el-table-column>
        <el-table-column
            prop="posts"
            align="center"
            label="领导职位"
            width="360px">
        </el-table-column>
        <el-table-column
            prop="sort"
            align="center"
            label="排序等级"
            width="300px"
        >
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="240px"
            class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
            >修改</el-button>
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleDel(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          style="text-align: center"
          layout="prev, pager, next"
          :total="total"
          :current-page="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
<!--    新增框-->
    <el-dialog :title="title" :visible.sync="open" width="500px">
      <el-form ref="form" :model="leader">
        <el-form-item prop="leaderName" label="领导姓名：">
          <el-input v-model="leader.leaderName" type="text" style="width: 300px">
          </el-input>
        </el-form-item>
        <el-form-item prop="posts" label="领导职位：">
          <el-input v-model="leader.posts" type="text" style="width: 300px">
          </el-input>
        </el-form-item>
        <el-form-item prop="photo" label="证件照：">
          <div class="avatar-upload" style="width: 300px">
            <el-image v-if="imageUrl" :src="imageUrl" alt="Avatar" class="avatar-preview" style="width: 180px;height: 200px;margin-left: 160px"  @click="openFile()">
            </el-image>
            <div  v-else style="height: 180px;width: 180px;border: #c2c1c1 1px solid;margin-left: 150px;text-align: center" @click="openFile()">
              <el-icon class="el-icon-plus" style="font-size: 150px;margin-top: 15px"/>
            </div>
            <input type="file" ref="fileInput" @change="onFileChange" accept="image/*" style="display:none;">
<!--            <img v-if="imageUrl" :src="imageUrl" alt="Avatar" class="avatar-preview" >-->
<!--            <label v-else class="avatar-placeholder">-->
<!--              <i class="fas fa-user-circle"></i> 选择头像-->
<!--              <input type="file" ref="fileInput" @change="onFileChange" accept="image/*" style="display:none;">-->
<!--            </label>-->
          </div>
        </el-form-item>
        <el-form-item prop="sort" label="排序等级：">
          <el-input v-model="leader.sort" type="number" style="width: 300px">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" >提 交</el-button>
        <el-button @click="cancel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
import {addLeader, delLeader, getLeaderList, updateLeader} from "@/api/leader";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data(){
    return {
      imageUrl:undefined,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total:0,
      tableData:undefined,
      open:false,
      title:undefined,
      leader:{
        id: undefined,
        leaderName:undefined,
        photo:undefined,
        posts:undefined,
        sort: undefined
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    openFile(){
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.readFile(file);
    },
    readFile(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },

      handleDel(row){
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delData(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      this.getList()
    },
    delData(id){
      delLeader([id]).then(()=>{
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getList()
      })
    },
    handleUpdate(row){
      this.open=true
      this.title='修改领导'
      const data=JSON.stringify(row)
      this.leader=JSON.parse(data)
      this.imageUrl=row.photo
    },
    handleCurrentChange(pageNum){
      this.queryParams.pageNum=pageNum
      this.getList()
    },
    getList(){
      getLeaderList(this.queryParams).then(async res=>{
        const data=await  res.data
        this.tableData= data.content
        this.total=data.totalElements
      })
    },
    add(){
      this.open=true
      this.title="新增领导"
      this.leader={
        id: undefined,
        leaderName:undefined,
        photo:undefined,
        posts:undefined,
        sort: undefined
      }
      this.$refs['form'].resetFields()
    },
    submitForm(){
      this.leader.photo=this.imageUrl
      if(this.title=='新增领导'){
        addLeader(this.leader).then((res)=>{
          if(res.code==200){
            Message.success("新增成功")
            this.open=false
            this.getList()
          }else Message.error(res.msg)
        })
      }else {
        updateLeader(this.leader).then((res)=>{
          if(res.code==200){
            Message.success("修改成功")
            this.open=false
            this.getList()
          }else {
            Message.error(res.msg)
          }
        })

      }

    },
    cancel(){
      this.open=false
    }
  }
}
</script>

<style scoped>

</style>
